export const validateGroupName = (name: string) => {
  switch (name) {
    case 'mundoIds':
      return 'mundo'
    case 'mundoSelectIds':
      return 'mundo'
    case 'statusIds':
      return 'statusEstoque'
    case 'statusSelectIds':
      return 'statusEstoque'
    case 'periodoIds':
      return 'periodo'
    case 'periodoSelectIds':
      return 'periodo'
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'
    case 'categoriaIds':
      return 'categoria'
    case 'categoriaSelectIds':
      return 'categoria'
    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'
    case 'fornecedorIds':
      return 'fornecedor'
    case 'fornecedorSelectIds':
      return 'fornecedor'
    // case 'subCategoriaIds':
    //   return 'subCategoria'
    // case 'subCategoriaSelectIds':
    //   return 'subCategoria'
    default:
      return null
  }
}
